import Styles from "./DetailsHeader.module.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
const DetailsHeader = ({ heading, dispalyList, displayActive, status }) => {
  const navigation = useNavigate();

  const handleNav = (val) => {
    navigation(val);
  };

  const hideTabAndBackBtn = localStorage.getItem("hideBilateralTabs");

  return (
    <div className={`display_flex_row ${Styles.detailsHeader}`}>
      <div className={"display_flex_row_gap_8"}>
        <div
          onClick={() => navigation("/dashboard")}
          className={`display_flex_row_gap_4 ${Styles.backButton}`}
        >
          <ChevronLeftIcon style={{ fontSize: "16px" }} />
          <span>Back</span>
        </div>

        <div className={Styles.detailsHeadname}>{heading}</div>
      </div>

      {hideTabAndBackBtn === "false" && (
        <div className={`display_flex_row ${Styles.sectionNamain}`}>
          {dispalyList?.map((ele) => (
            <div
              type="button"
              onClick={() => {
                if (
                  (ele?.name === "Ongoing Connection" &&
                    !(
                      status === "ONGOING" ||
                      status === "CLOSED" ||
                      status === "SCHEDULED"
                    )) ||
                  (ele?.name === "Active Connection" && status === "ACTIVE")
                )
                  return;
                handleNav(ele?.url);
              }}
              role="button"
              style={{
                cursor:
                  (ele?.name === "Ongoing Connection" &&
                    !(
                      status === "ONGOING" ||
                      status === "CLOSED" ||
                      status === "SCHEDULED"
                    )) ||
                  (ele?.name === "Active Connection" && status === "ACTIVE")
                    ? "not-allowed"
                    : "pointer",
              }}
              className={`display_flex_row_center ${
                displayActive === ele?.name && Styles.activeSection_Nav_section
              }`}
            >
              {ele?.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DetailsHeader;
